<p-dialog 
    header="Documents"
    [modal]="true"
    [style]="{width: '95vw'}"
    [(visible)]="visible"
    (onHide)="closeDocumentsDialog()" 
    [draggable]="false"
>

  <p-toast position="top-right" appendTo="body" [baseZIndex]="20000"></p-toast>
<app-doc-summary-generation-select-dialog [showdialog]="showdialog" [selectedDocForSummary]="selectedDocForSummary"
    (emitSummaryForDoc)="emitSummary($event)" (closeDialog)="closeDialog($event)">
</app-doc-summary-generation-select-dialog>

<app-document-summary-sidebar
    *ngIf="dialogType === 'sideBar'"
    [sidebarVisible]="sidebarVisible"
    (emitSidebarUpdate)="updateSidebar($event)"
    [summaryData]="summaryData"
    [header]="headerSummary"
    [documentName]="summaryDocumentName"
    [documentModel]="documentModelForSummary"
></app-document-summary-sidebar>
<app-table-summary-sidebar
    *ngIf="dialogType === 'table'"
    [sidebarVisible]="sidebarVisible"
    (emitSidebarUpdate)="updateSidebar($event)"
    [summaryData]="summaryData"
    [header]="headerSummary"
    [documentName]="summaryDocumentName"
    [documentModel]="documentModelForSummary"
></app-table-summary-sidebar>
<app-document-summary-dialog
    *ngIf="dialogType === 'documentSummary'"
    [sidebarVisible]="sidebarVisible"
    (emitSidebarUpdate)="updateSidebar($event)"
    [summaryData]="summaryData"
    [header]="headerSummary"
    [longSummaryType]="longSummaryType"
    [documentName]="summaryDocumentName"
    [documentModel]="documentModelForSummary"
></app-document-summary-dialog>
<app-confirmation-dialog [message]="dialogMessage" [display]="displayConfirmationDialog" [type]="displayDialogType"
    (accept)="ondialogaccept()" (cancel)="onCancelDialog()"></app-confirmation-dialog>
<app-fileupload-metadata-dialog [display]="displayCSVUploadDialog" [CSVFiles]="CSVFiles" [tableNames]="CSVTablesData"
    (accept)="this.displayCSVUploadDialog = false; submitFileUploadDialog($event)"
    (cancel)="filemetaDataClosing($event)"></app-fileupload-metadata-dialog>
<app-excel-tables-info [display]="displayExcelInfoDialog" (cancel)="closeInFoSlider($event)">
</app-excel-tables-info>
  <div class="docContainer">
    <div class="docactions">
        <div class="p-input-icon-left searchContainer">
            <i class="pi pi-search"></i>
            <input pInputText class="searchInput p-inputtext pr-5" type="text"
                (keydown)="this.searchTextUpdate.next($event)" [(ngModel)]="searchText"
                placeholder="Search Documents" />
            <i *ngIf="searchText?.length > 0"
                (click)="searchText = ''; isloading=true;  docsList=[]; getAllDocs()"
                (keydown.enter)="searchText = ''; isloading=true;  docsList=[]; getAllDocs()"
                (keydown.space)="searchText = ''; isloading=true;  docsList=[]; getAllDocs()"
                tabindex="0" role="button"
                class="pi pi-times cursor searchCancel"></i>
        </div>
        <div class="buttonContainer">
            <input id="file" class="file-input pt-2" type="file"
                accept=".pdf, .ppt, .pptx, .docx, .txt, .csv, .xlsx, .xls" (change)="fileSelect($event, false)"
                #fileUpload multiple 
            />
            <button type="button" [disabled]="addingDocLoader" (click)="fileUpload.click()"
                class="p-button p-button-outlined-secondary btnMargin cursor">
                <span *ngIf="addingDocLoader" class="loaderSpinner mx-1"></span>
                <i *ngIf="!addingDocLoader" class="bi bi-file-earmark mx-1"></i>
                <span class="mr-1 add-attachment-label"> Add File</span>
            </button>

            <input id="folder" class="file-input pt-2" type="file"
                accept=".pdf, .ppt, .pptx, .docx, .txt, .csv, .xlsx, .xls" (change)="fileSelect($event, true)"
                #folderUpload multiple webkitdirectory
            />
            <button type="button" [disabled]="addingFolderLoader" (click)="folderUpload.click()"
                class="p-button p-button-outlined-secondary btnMargin cursor">
                <span *ngIf="addingFolderLoader" class="loaderSpinner mx-1"></span>
                <i *ngIf="!addingFolderLoader" class="bi bi-folder mx-1"></i>
                <span class="mr-1 add-attachment-label"> Add Folder</span>
            </button>
        </div>

        <button *ngIf=" (selectedDocs.length>0 && !chatwithDocs)" type="button"
            [disabled]="addingDocLoader || addingFolderLoader" (click)="deleteSelectedConfirmationDialog()"
            class="p-button p-button-outlined-danger btnMargin mr-0 cursor">
            <i class="bi bi-trash mx-1"></i>
        </button>
    </div>

    <div>
        <div *ngIf="isloading" class="loadingContainer">
            <app-loader [isLoading]="isloading"></app-loader>
        </div>
        <div class="ngTable" (scroll)="scrollUpdate.next($event)" *ngIf="!isloading && activeTabIndex === 0">
            <p-table
                [columns]="displayedColumns"
                [value]="organizedDocsList"
                scrollHeight="calc(100vh - 280px)"
                (onRowSelect)="onRowSelect($event)"
                (onRowUnselect)="onRowUnselect($event)"
                [(selection)]="selectedDocs"
                (onHeaderCheckboxToggle)="onSelectAll($event)"
                [tableLayout]="'fixed'"
            >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th scope="col" class="checkbox">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th scope="col" class="nameCol">File</th>
                        <th scope="col" class="csvIcon"></th>
                        <th scope="col">Status</th>
                        <th scope="col" class="aboutCol-width">About</th>
                        <th scope="col">Uploaded At</th>
                        <th scope="col">Summary</th>
                        <th scope="col">Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="rowData.documentId">
                        <td>
                            <p-tableCheckbox [value]="rowData" [disabled]="
                              (rowData.documentStatus === documentArchived &&
                              (excelFileTypes.includes(rowData.contentType) || csvFileTypes.includes(rowData.contentType)))"></p-tableCheckbox>
                        </td>
                        <td tooltipPosition="top" pTooltip="{{ rowData?.documentName | titlecase }}"
                            class="nameCol">
                            <div *ngIf="rowData.type === 'Folder'" (click)="toggleFolder(rowData.documentId)"
                                (keydown.enter)="toggleFolder(rowData.documentId)" (keydown.space)="toggleFolder(rowData.documentId)"
                                tabindex="0" role="button" class="folder-icon cursor">
                                <i class="bi bi-folder-fill folderColor"
                                    *ngIf="!expandedFolders[rowData.documentId]"></i>
                                <i class="pi pi-folder-open folderColor"
                                    *ngIf="expandedFolders[rowData.documentId]"></i>
                                {{ rowData.documentName }}
                            </div>
                            <div *ngIf="rowData.type === 'file'">{{ rowData.documentName.length > 40 ?
                                (rowData.documentName |
                                slice : 0 : 38) + '...' : rowData.documentName }}</div>
                        </td>
                        <td>
                            <i *ngIf="excelFileTypes.includes(rowData.contentType) || csvFileTypes.includes(rowData.contentType)"
                                class="bi bi-table"></i>
                        </td>
                        <td>
                          <div  class="flex flex-column align-items-center justify-content-center">
                            <div *ngIf="rowData.type === 'file' else folderStatus"
                                [ngClass]="getDocStatusClass(rowData)">
                                <div class="px-1" tooltipPosition="top"
                                    pTooltip="{{ rowData?.documentStatus | titlecase }}">
                                    {{ rowData?.documentStatus | titlecase }}
                                </div>
                            </div>
                            <ng-template #folderStatus>
                                <span>-</span>
                            </ng-template>
                            <div class="m-1" *ngIf="rowData?.processedEmbeddingsPercentage !== null && rowData?.processedEmbeddingsPercentage !== undefined && rowData?.documentStatus===documentStatusTextOnly">
                              <span class="processingpercent"><i class="loaderSpinner mr-1"></i>Processing {{Math.ceil(rowData.processedEmbeddingsPercentage)}}%</span>
                            </div>
                            </div>
                        </td>
                        <td class="aboutCol-width">
                            <div class="cursor" (click)="showAbout(rowData)" (keydown.enter)="showAbout(rowData)" (keydown.space)="showAbout(rowData)" tabindex="0" role="button"
                                *ngIf="((rowData.shortSummary || rowData.dataDictionary) && rowData.documentStatus !== documentProcessing) else noData">
                                <ng-container *ngIf="rowData.dataDictionary">
                                    <span class="hyperlink"> Click here to see data dictionary </span>
                                </ng-container>
                                <ng-container *ngIf="!rowData.dataDictionary">
                                    {{ truncateSummary(rowData.shortSummary, 100) }}
                                </ng-container>
                                <ng-container *ngIf="rowData.type === 'Folder'">
                                    <span>-</span>
                                </ng-container>
                            </div>
                            <ng-template #noData>
                                <div *ngIf="rowData.documentStatus === documentProcessing">
                                    <i class="loaderSpinner"></i>
                                </div>
                                <div *ngIf="rowData.documentStatus !== documentProcessing" class="flex pl-4">
                                    -
                                </div>
                            </ng-template>
                        </td>
                        <td>{{ rowData.createdAt | date: 'dd MMM yyyy HH:mm' }}</td>
                        <td class="summaryCol">
                            <div class="flex  justify-content-start align-items-center">
                                <div [ngClass]="getButtonClass(rowData)" tooltipPosition="top"
                                    pTooltip="{{ rowData?.summaryStatus | titlecase }}">
                                    <button
                                    *ngIf="!((rowData.documentStatus !== documentProcessed && rowData.documentStatus !== documentArchived) ||
                                              excelFileTypes.includes(rowData.contentType) ||
                                              csvFileTypes.includes(rowData.contentType) ||
                                              (rowData.type && rowData.type === 'Folder')) && !rowData['loader']"
                                    class="p-button p-button-outlined-secondary btnMargin cursor m-0"
                                    [ngClass]="{
                                      'completed-summary': rowData?.summaryStatus === 'completed',
                                      'processing-summary': rowData?.summaryStatus === 'processing',
                                      'failed-summary': rowData?.summaryStatus === 'failed'
                                    }"
                                    (click)="(showSummary(rowData?.summaryStatus) || showProcessingSummary(rowData?.summaryStatus)) && !rowData['loader'] ? openSummarySidebar(rowData): !rowData?.summaryStatus || rowData?.summaryStatus === 'failed' ? (openDialog(rowData)):''"
                                  >
                                    <i
                                      *ngIf="(showSummary(rowData?.summaryStatus) || showProcessingSummary(rowData?.summaryStatus)) && !rowData['loader']"
                                      class="bi bi-file-earmark-check-fill mr-1"
                                    ></i>
                                    <i
                                      *ngIf="showFailedSummary(rowData?.summaryStatus) && !rowData['loader']"
                                      class="bi bi-file-earmark-excel-fill mr-1"
                                    ></i>

                                    <i
                                      *ngIf="!rowData?.summaryStatus"
                                      class="bi bi-play mr-1 docSummary cursor"
                                      [disabled]="true"
                                      tooltipPosition="top"
                                      pTooltip="Generate Summary"
                                    ></i>

                                    {{ rowData?.summaryStatus ? (rowData?.summaryStatus === 'completed' ? ' Read' : rowData?.summaryStatus === 'processing' ?'Processing':'Retry') : 'Generate' }}
                                  </button>
                                    <i *ngIf="rowData['loader']" class="loaderSpinner"></i>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="me-1 docactions">
                                <i (click)="openRetriggerConfirmation(rowData, rowIndex)"
                                    (keydown.enter)="openRetriggerConfirmation(rowData, rowIndex)"
                                    (keydown.space)="openRetriggerConfirmation(rowData, rowIndex)"
                                    tabindex="0" role="button"
                                    class="bi bi-arrow-clockwise reload mr-1 retryDoc"
                                    [ngClass]="rowData.documentStatus !== documentFailed || (excelFileTypes.includes(rowData.contentType) || csvFileTypes.includes(rowData.contentType)) ? 'visibilityHidden' : ''"
                                    pTooltip="Retry" tooltipPosition="top"></i>
                                <i class="bi bi-file-earmark-break mr-1 docSummary cursor" *ngIf="rowData.documentRevisionsStatus === summaryCompleted && rowData.documentRevisions"
                                    [disabled]="true" tooltipPosition="top" pTooltip="Document Revisions"
                                    (click)="showDocumentUpdates(rowData)"
                                    (keydown.enter)="showDocumentUpdates(rowData)"
                                    (keydown.space)="showDocumentUpdates(rowData)"
                                    tabindex="0" role="button"></i>
                                <i *ngIf="(this.docLoaders[rowData.documentId] && this.docLoaders[rowData.documentId]['deleteLoader'] === true) || rowData.documentRevisionsStatus === summaryProcessing "
                                    class="loaderSpinner mr-2"></i>
                                <i *ngIf="!(this.docLoaders[rowData.documentId] && this.docLoaders[rowData.documentId]['deleteLoader'] === true)"
                                    pTooltip="Delete" tooltipPosition="top"
                                    (click)="deleteConfirmationDialog(rowData, rowIndex)"
                                    (keydown.enter)="deleteConfirmationDialog(rowData, rowIndex)"
                                    (keydown.space)="deleteConfirmationDialog(rowData, rowIndex)"
                                    tabindex="0" role="button"
                                    class="bi bi-trash mr-2 cursor docDelete"></i>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="rowData.type === 'Folder' && expandedFolders[rowData.documentId]">
                        <td colspan="9" class="nested-files">
                            <p-table [columns]="displayedColumns" [value]="rowData['files']"
                                scrollable="true"
                                scrollHeight="calc(100vh - 420px)" [(selection)]="selectedDocs"
                                class="custom-table-style">
                                <ng-template pTemplate="body" let-fileRow let-columns="columns"
                                    let-fileRowIndex="fileRowIndex">
                    <tr>

                        <td class="checkboxcol-nested" >
                            <div class="flex">
                            <p-tableCheckbox [value]="fileRow" [disabled]="
                  (fileRow.documentStatus === documentArchived &&
                  (excelFileTypes.includes(fileRow.contentType) || csvFileTypes.includes(fileRow.contentType)))">
                            </p-tableCheckbox>
                            </div>
                        </td>
                        <td  class="nameCol-nested" tooltipPosition="top" pTooltip="{{ fileRow?.documentName | titlecase }}"
                            >
                            <div class="flex mx-2 mt-1">
                                {{ fileRow.documentName.length > 40 ? (fileRow.documentName | slice : 0 : 38) +
                                '...' : fileRow.documentName }}
                                <i *ngIf="excelFileTypes.includes(fileRow.contentType) || csvFileTypes.includes(fileRow.contentType)"
                                    class="bi bi-table tableIcon"></i>
                            </div>
                        </td>
                        <td>
                          <i *ngIf="excelFileTypes.includes(fileRow.contentType) || csvFileTypes.includes(fileRow.contentType)"
                              class="bi bi-table"></i>
                          </td>
                        <td>
                          <div class="statusCol-nested mr-2">
                            <div [ngClass]="getDocStatusClass(fileRow)">
                                <div class="px-1" tooltipPosition="top"
                                    pTooltip="{{ fileRow?.documentStatus | titlecase }}">
                                    {{ fileRow?.documentStatus | titlecase }}
                                </div>
                            </div>
                               <div class="m-1" *ngIf="rowData?.processedEmbeddingsPercentage !== null && rowData?.processedEmbeddingsPercentage !== undefined && (rowData?.documentStatus===documentStatusTextOnly || rowData?.documentStatus===documentProcessing)">
                              <span class="processingpercent"><i class="loaderSpinner mr-1"></i>Processing {{Math.ceil(rowData.processedEmbeddingsPercentage)}}%</span>
                            </div>
                            </div>
                        </td>
                        <td class="aboutCol-width-nested">
                            <div class="cursor" (click)="showAbout(fileRow)" (keydown.enter)="showAbout(fileRow)" (keydown.space)="showAbout(fileRow)" tabindex="0" role="button"
                                *ngIf="((fileRow.shortSummary || fileRow.dataDictionary) && fileRow.documentStatus !== documentProcessing) else noData">
                                <ng-container *ngIf="fileRow.dataDictionary">
                                    <span class="hyperlink"> Click here to see data dictionary </span>
                                </ng-container>
                                <ng-container *ngIf="!fileRow.dataDictionary">
                                    {{ truncateSummary(fileRow.shortSummary, 100) }}
                                </ng-container>
                            </div>
                            <ng-template #noData>
                                <div *ngIf="fileRow.documentStatus === documentProcessing">
                                    <i class="loaderSpinner"></i>
                                </div>
                                <div *ngIf="fileRow.documentStatus !== documentProcessing" class="flex pl-4">-
                                </div>
                            </ng-template>
                        </td>
                        <td class="uploadedAtCol-nested">{{ fileRow.createdAt | date: 'dd MMM yyyy HH:mm' }}</td>
                        <td class="summaryCol-nested">
                          <div class="flex  justify-content-start align-items-center">

                            <div [ngClass]="getButtonClass(fileRow)" tooltipPosition="top"
                                pTooltip="{{ fileRow?.summaryStatus | titlecase }}">
                                <button
                                *ngIf="!((fileRow.documentStatus !== documentProcessed && fileRow.documentStatus !== documentArchived) ||
                                          excelFileTypes.includes(fileRow.contentType) ||
                                          csvFileTypes.includes(fileRow.contentType) ||
                                          (fileRow.type && fileRow.type === 'Folder')) && !fileRow['loader']"
                                class="p-button p-button-outlined-secondary btnMargin cursor m-0"
                                [ngClass]="{
                                  'completed-summary': fileRow?.summaryStatus === 'completed',
                                  'processing-summary': fileRow?.summaryStatus === 'processing'
                                }"
                                (click)="(showSummary(fileRow?.summaryStatus) || showFailedSummary(fileRow?.summaryStatus) || showProcessingSummary(fileRow?.summaryStatus)) && !fileRow['loader'] ? openSummarySidebar(fileRow): !fileRow?.summaryStatus ? (openDialog(fileRow)):''"
                              >
                                <i
                                  *ngIf="(showSummary(fileRow?.summaryStatus) || showFailedSummary(fileRow?.summaryStatus) || showProcessingSummary(fileRow?.summaryStatus)) && !fileRow['loader']"
                                  class="bi bi-file-earmark-check-fill"fileRow
                                ></i>

                                <i
                                  *ngIf="!fileRow?.summaryStatus"
                                  class="bi bi-play mr-1 docSummary cursor"
                                  [disabled]="true"
                                  tooltipPosition="top"
                                  pTooltip="Generate Summary"
                                ></i>

                                {{ fileRow?.summaryStatus ? (fileRow?.summaryStatus === 'completed' ? ' Read' : fileRow?.summaryStatus === 'processing' ?'Processing':'') : 'Generate' }}
                              </button>
                                <i *ngIf="fileRow['loader']" class="loaderSpinner"></i>
                            </div>
                        </div>

                        </td>
                        <td>
                            <div class="me-1 docactions">
                                <i (click)="openRetriggerConfirmation(fileRow, fileRowIndex)"
                                    (keydown.enter)="openRetriggerConfirmation(fileRow, fileRowIndex)"
                                    (keydown.space)="openRetriggerConfirmation(fileRow, fileRowIndex)"
                                    tabindex="0" role="button"
                                    class="bi bi-arrow-clockwise reload mr-1 retryDoc"
                                    [ngClass]="fileRow.documentStatus !== documentFailed || (excelFileTypes.includes(fileRow.contentType) || csvFileTypes.includes(fileRow.contentType)) ? 'visibilityHidden' : ''"
                                    pTooltip="Retry" tooltipPosition="top"></i>
                                <i class="bi bi-play mr-1 docSummary cursor"
                                    [class.disabled-icon]="(fileRow.documentStatus !== documentProcessed && fileRow.documentStatus !== documentArchived) || (fileRow.summaryStatus && fileRow.summaryStatus === 'processing') || excelFileTypes.includes(fileRow.contentType) || csvFileTypes.includes(fileRow.contentType)"
                                    [disabled]="true" tooltipPosition="top" pTooltip="Generate Summary"
                                    (click)="openDialog(fileRow)"
                                    (keydown.enter)="openDialog(fileRow)"
                                    (keydown.space)="openDialog(fileRow)"
                                    tabindex="0" role="button"></i>
                                <i class="bi bi-file-earmark-break mr-1 docSummary cursor" *ngIf="fileRow.documentRevisionsStatus === summaryCompleted && fileRow.documentRevisions"
                                    [disabled]="true" tooltipPosition="top" pTooltip="Document Revisions"
                                    (click)="showDocumentUpdates(fileRow)"
                                    (keydown.enter)="showDocumentUpdates(fileRow)"
                                    (keydown.space)="showDocumentUpdates(fileRow)"
                                    tabindex="0" role="button"></i>
                                <i *ngIf="(this.docLoaders[fileRow.documentId] && this.docLoaders[fileRow.documentId]['deleteLoader'] === true) || fileRow.documentRevisionsStatus === summaryProcessing "
                                    class="loaderSpinner mr-2"></i>
                                <i *ngIf="!(this.docLoaders[fileRow.documentId] && this.docLoaders[fileRow.documentId]['deleteLoader'] === true)"
                                    pTooltip="Delete" tooltipPosition="top"
                                    (click)="deleteConfirmationDialog(fileRow, fileRowIndex)"
                                    (keydown.enter)="deleteConfirmationDialog(fileRow, fileRowIndex)"
                                    (keydown.space)="deleteConfirmationDialog(fileRow, fileRowIndex)"
                                    tabindex="0" role="button"
                                    class="bi bi-trash mr-2 cursor docDelete"></i>
                                <i *ngIf="(this.docLoaders[fileRow.documentId] && this.docLoaders[fileRow.documentId]['deleteLoader'] === true)"
                                    class="loaderSpinner mr-2"></i>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            </td>
            </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" class="emptymessage">
                <tr>
                    <td colspan="12">
                        <div class="noData">No Document Available</div>
                    </td>
                </tr>
            </ng-template>
            </p-table>

        </div>
        <div *ngIf="loadmoreLoading && docsList.length > 0 && !isloading" class="flexEnd load-more mt-1">
            Loading...
        </div>
    </div>
</div>
<ng-template pTemplate="footer">
  <div class="flex justify-content-end">
    <button type="button"
        [disabled]="selectedDocs.length === 0 || addingDocLoader || addingFolderLoader || chatwithDocs"
        (click)="checkChatDocs()" class="p-button p-button-primary btnMargin">
        <span *ngIf="chatwithDocs" class="loaderSpinnerWhite mr-2"></span>
        Chat with Documents
    </button>
  </div>
</ng-template>

</p-dialog>
